import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { OverlayService } from 'src/app/services/overlay.service';
import { RssService } from 'src/app/services/rss.service';

@Component({
  selector: 'app-rss-feed',
  templateUrl: './rss-feed.component.html',
  styleUrls: ['./rss-feed.component.scss']
})
export class RssFeedComponent implements OnInit {
  /**
   * The Columns of the Table
   */
  displayedColumns = ['number', 'image', 'feedUri', 'type', 'menu'];
  /**
   * The current Page
   */
  page = null;
  /**
   * The Pagemetadata
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  /**
   * The Data to be displayed
   */
  dataSource: MatTableDataSource<any>;
  /**
   * constructor
   * @param rss 
   * @param overlay 
   * @param router 
   * @param route 
   */
  constructor(
    private rss: RssService,
    private overlay: OverlayService,
    private router: Router,
    private route: ActivatedRoute
  ) { }
  /**
   * ngOnInit
   */
  ngOnInit() {
    this.rss.getRssFeeds(0, 12).subscribe((rss: PagedResources<any>) => {
      this.dataSource = new MatTableDataSource(rss.content);
      this.page = rss.page
    })
  }
  /**
   * Load the Page of RSS-Feeds
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  /**
   * Search for the Page of RSS-Feeds
   */
  search(pageIndex, pageSize) {
    this.rss.getRssFeeds(pageIndex, pageSize).subscribe((rss: PagedResources<any>) => {
      this.dataSource = new MatTableDataSource(rss.content);
      this.page = rss.page
    })
  }
  /**
   * Delte a RSS-Feed
   * @param ID 
   */
  deleteRssFeeds(ID) {
    this.rss.deleteRssFeeds(ID).subscribe(fromDelete => {
      this.overlay.openSnackBar("RSS-Feed erfolgreich gelöscht!");
      this.rss.getRssFeeds(0, 12).subscribe((rss: PagedResources<any>) => {
        this.dataSource = new MatTableDataSource(rss.content);
        this.page = rss.page
      })
    })
  }

  /**
   * Manually get the lastest entries for the Feed
   * @param feed 
   */
  refreshRssFeed(feed) {
    this.rss.refreshRssFeed(feed).subscribe(fromrefresh => {
      this.overlay.openSnackBar("RSS-Feed erfolgreich aktualisiert!");
      this.rss.getRssFeeds(0, 12).subscribe((rss: PagedResources<any>) => {
        this.dataSource = new MatTableDataSource(rss.content);
        this.page = rss.page
      })
    })
  }
}
